﻿import * as HttpDataServiceBase from '../core/httpdataservicebase';
import * as Model from "../models/models";
import {ILogService} from '../core/services/logservice/log.service';
import * as MessageBarService from '../core/services/messageBarService/messageBar.service';
import IAppSettings from '../../iApp.settings';
import {IPaymentMethod} from "../models/models";


export class PaymentRepository extends HttpDataServiceBase.DataServiceBase<Model.PaymentRequest> {

    static $inject = ['$q', '$http', 'logService', 'appSettings', 'messageBarService'];

    constructor($q: ng.IQService, $http: ng.IHttpService, logger: ILogService, appSettings: any, messageBarService: MessageBarService.MessageBarService) {
        super($q, $http, logger, messageBarService, appSettings.apiPath + '/payments');

        this.appSettings = appSettings;
    }

    private appSettings: IAppSettings;

    public getCardPaymentMethods(policyHolderId: string): ng.IPromise<any> {

        const url = `${this.appSettings.apiPath}/paymenttokens/card/${policyHolderId}`;

        return this.$http.get(url)
            .then((response: ng.IHttpPromiseCallbackArg<Model.ICardPaymentMethod[]>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }

    public getEcheckPaymentMethods(policyHolderId: string): ng.IPromise<any> {

        const url = `${this.appSettings.apiPath}/paymenttokens/echeck/${policyHolderId}`;

        return this.$http.get(url)
            .then((response: ng.IHttpPromiseCallbackArg<Model.IEcheckPaymentMethod[]>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }

    public makePayment(paymentRequest:Model.IPaymentRequest): ng.IPromise<any> {

        const url = `${this.appSettings.apiPath}/payments/request`;

        return this.$http.post(url, paymentRequest)
            .then((response: ng.IHttpPromiseCallbackArg<Model.IPaymentResponse>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
        
    }

    public paymentSummarySearchAsync(searchCriteria: Model.IPaymentSummarySearchCriteria): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/paymentsummary/search`;

        return this.$http.post(url, searchCriteria)
            .then((response: ng.IHttpPromiseCallbackArg<Array<Model.IPaymentSummary>>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }

    public paymentRequestSearchByMerchantReferenceAsync(searchCriteria: Model.IPaymentSearchByMerchantReferenceCriteria): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/paymentrequest/search/merchantreference`;

        return this.$http.post(url, searchCriteria)
            .then((response: ng.IHttpPromiseCallbackArg<Array<Model.IPaymentRequest>>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }

    public paymentResponseSearchAsync(searchCriteria: Model.IPaymentResponseSearchCriteria): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/paymentresponse/search`;

        return this.$http.post(url, searchCriteria)
            .then((response: ng.IHttpPromiseCallbackArg<Array<Model.IPaymentResponse>>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
    }

    public updateAutoPayToken(tokenid: string): ng.IPromise<any> {
        const url = `${this.appSettings.apiPath}/paymenttokens/${tokenid}`;

        return this.$http.post(url,tokenid)
            .then((response: ng.IHttpPromiseCallbackArg<Model.IPaymentRequest>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));
        
    }

    public updatePaymentMethod(paymentMethod:IPaymentMethod): ng.IPromise<any>{
        const url = `${this.appSettings.apiPath}/paymenttokens`;
         return this.$http.put(url,paymentMethod)
            .then((response: ng.IHttpPromiseCallbackArg<Model.IPaymentMethod>) => this.successHandler(response))
            .catch((error: ng.IHttpPromiseCallbackArg<any>) => this.errorHandler(error));

    }



}
